import React from 'react'

const HeroSection = () => {
  return (
    <div className=" flex items-center justify-center text-center bg-cover  bg-no-repeat h-[313px]"  style={{ backgroundImage: "url('/contact-banner.png')" }}>

      <div className="flex flex-col justify-between px-6">
        
      <p className="text-white small:text-[39px] text-3xl  font-semibold mt-2  small:animate-typing small:overflow-hidden small:whitespace-nowrap ">We're Here To Help</p>
        <h1 className="text-[#FFC400] small:text-4xl text-3xl  md:text-[62px] font-bold mt-5 uppercase">Contact Us</h1>
       
      </div>
    </div>
  )
}

export default HeroSection